exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.am-telephony a[data-v-7e08c336] {\n  color: #044e99;\n  cursor: pointer;\n}\n", ""]);

// exports
